import { StyleSheet, Text, View } from 'react-native'
import { useEffect, useState } from 'react'
import React from 'react'
//store
import { usePersonalStore } from '../../stores/personalInfo'
// styles
import { fontPalette, globalStyles } from '../../static/styles/global'
//component
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import Card from '../../components/shared/card/Card'
import CardSeparator from '../../components/shared/card/CardSeparator'
import { en } from '../../i18n/FormSelect'
//Translation
import { useTranslation } from 'react-i18next'
import CustomButton from '../../components/shared/button/Button'
import { useHomeStore } from '../../stores/home'
import moment from 'moment'
import { useLabourStore } from '../../stores/labour'
import { Loading } from '../../components/shared/navigator/Loading'



const ProfileViewscreen = ({ navigation, route }) => {
  // params
  const { params } = route
  const { mostRecentUserOnBoardings: userId, states } = params
  const { loading, error, personalData, fetchData, updateData } =
    usePersonalStore()
  const { getTimeClockId, labourData, timeClockData, loading: labourStoreLoading, error: labourStoreError } = useLabourStore()
  const { homeData } = useHomeStore()

  const homestore = useHomeStore()
  useEffect(() => {
    fetchData(userId)
  }, [])

  useEffect(() => {
    if (homeData?.isOnboarded) {
      getTimeClockId(labourData?.userId ? labourData?.userId : 0)
    }
  }, [homeData?.isOnboarded, labourData?.userId])

  const Row = ({ label, value }) => (
    <View style={styles.row}>
      <View style={styles.leftColumn}>
        <Text style={styles.label}>{label}</Text>
      </View>
      <Text style={styles.colon}>:</Text>
      <View style={styles.rightColumn}>
        <Text style={styles.value}>{value}</Text>
      </View>
    </View>
  )

  const fullName = `${personalData?.firstName} ${personalData?.middleInitial} ${personalData?.lastName}`
  const ssnLastFour = `XXX-XX-${personalData?.ssnLastFour}`
  const Address = `${personalData?.addressLine1}`
  const Address2 = `${personalData?.addressLine2}`
  const state = en.states.find(
    (state) => state.code === personalData?.stateValue
  )
  const stateName = state ? state.name : 'Unknown'
  const inputDate = `${personalData?.dateOfBirth}`
  const formattedDate = moment(inputDate).isValid() ? moment(inputDate).format('MM/DD/YYYY') : '';
  // const date = new Date(inputDate)
  // const formatter = new Intl.DateTimeFormat('en', {
  //   year: 'numeric',
  //   month: '2-digit',
  //   day: '2-digit'
  // })
  // const formattedDate = formatter.format(date)
  const gender = en.gendersLookup.find(
    (gender) => gender.genderValue === personalData?.genderValue
  )
  const genderdescription = gender ? gender.genderDescription : 'Unknown'
  const marital = en.maritalStatusesLookup.find(
    (marital) => marital.maritalStatusValue === personalData?.maritalStatusValue
  )
  const EmployeeDiscount = personalData?.employeeDiscount;
  const AxonifyUserID = personalData?.axonifyUserID
  const maritalDescription = marital
    ? marital.maritalStatusDescription
    : 'Unknown'
  const { t } = useTranslation()

  if (loading || labourStoreLoading) {
    return <Loading />

  }
  return (
    <>
      <View
        style={[globalStyles.primaryBgColor, globalStyles.containerBandMenu]}
      >
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>

      </View>
      <View style={[globalStyles.flexOne, globalStyles.containerOverlap]}>
        <Card>
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs18,
                globalStyles.blackTextColor
              ]}
            >
              {t('myprofile')}
            </Text>
            {homeData?.isOnboarded &&

              <CustomButton text={t("Edit")} onPress={() => navigation.navigate("UpdatePersonalBasicInformationScreen")} />}
          </View>
          <CardSeparator light={true} />




          <Row label={t('name')} value={fullName} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('email')} value={personalData?.employeeEmailAddress} />
          <View style={[globalStyles.mb2]} />
          <Row label="SSN" value={ssnLastFour} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('address')} value={Address} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('Address 2')} value={Address2} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('city')} value={personalData?.city} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('state')} value={stateName} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('dateofbirth')} value={formattedDate} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('gender')} value={genderdescription} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('phonenumber')} value={personalData?.mainPhoneNumber} />
          <View style={[globalStyles.mb2]} />
          <Row label={t('maritalstatus')} value={maritalDescription} />
          <View style={[globalStyles.mb2]} />
          {AxonifyUserID && <>
            <Row label={t('Axonify User ID')} value={AxonifyUserID} />
            <View style={[globalStyles.mb2]} />
          </>}
          {EmployeeDiscount && <>
            <Row label={t('Employee Discount')} value={EmployeeDiscount} />
            <View style={[globalStyles.mb2]} />
          </>}
          {homeData?.isOnboarded && timeClockData &&
            <>
              <Row label={t('Employee ID')} value={labourData?.employeeNumber} />
              <View style={[globalStyles.mb2]} />
              <Row label={t('Timeclock ID')} value={timeClockData?.data?.timeClockId} />
              <View style={[globalStyles.mb2]} />
            </>
          }


          {/* {homeData?.isOnboarded && <>
            <CardSeparator light={true} />
            <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
              <CustomButton
                text={t("Forms")}
                onPress={() => navigation.navigate("OnboardingForms")} />

            </View>
          </>
          } */}
        </Card>




      </View>
    </>
  )
}

export default ProfileViewscreen

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  leftColumn: {
    flex: 3,
    textAlign: 'right'
  },
  colon: {
    flex: 1,
    textAlign: 'center'
  },
  rightColumn: {
    flex: 5,
    flexDirection: 'row',
    textAlign: 'left'
  },
  valueWrapper: {
    flex: 1
  },
  label: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: fontPalette.primaryBold
  },
  value: {
    fontSize: 16,
    fontFamily: fontPalette.primaryLight
  }
})
